import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import StockOrientationSelect from '../../../common/StockOrientationSelect';

const BackgroundImagesOrientationSelect = (props) => {
    const {
        onOrientationChange,
        backgroundStockImagesOrientation,
        setBackgroundStockImagesOrientation
    } = props;

    return (
        <StockOrientationSelect
            onOrientationChange={onOrientationChange}
            mediaOrientation={backgroundStockImagesOrientation}
            setStockMediaOrientation={setBackgroundStockImagesOrientation}
        />
    );
};

const mapStateToProps = (state) => {
    const {
        backgroundStockImagesOrientation
    } = state.mediaPicker;

    return {
        backgroundStockImagesOrientation
    };
}

const mapDispatchToProps = (dispatch) => {
    const setLogoStockImagesOrientation = (orientation) => dispatch(mediaPickerActions.setLogoStockImagesOrientation(orientation));
    const setBackgroundStockImagesOrientation = (orientation) => dispatch(mediaPickerActions.setBackgroundStockImagesOrientation(orientation));

    return {
        setLogoStockImagesOrientation,
        setBackgroundStockImagesOrientation
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundImagesOrientationSelect);